function limitRows(_val) {
  if(!arguments.length) {
    let num = this.__attrs__.limitRows;
    if (num) {
      let data = this.data();
      if (this.aggregated()) {
        data.children = data.children.slice(0, num);
      } else {
        data = data.slice(0, num);
      }
      this.data(data);
    }
  } else {
    this.__attrs__.limitRows = _val;
  }
}

export default limitRows;


// WEBPACK FOOTER //
// ./layouts/default/limitRows.js